import { isDev } from '@/utils/helpers';

//* Function to lazy load pages
function lazyLoad(view) {
  return () => {
    return import(
      /* webpackPrefetch: true */ /* webpackChunkName: "[request]" */ `@/views/admin/${view}`
    );
  };
}
//* Function to lazy load pages
function lazyLoadMetrics(view) {
  return () => {
    return import(
      /* webpackPrefetch: true */ /* webpackChunkName: "[request]" */ `@/views/admin/metrics/${view}`
    );
  };
}
// component: lazyLoad('ClubhouseDashboardPage'),

const adminRoutes = {
  path: '/admin',
  component: () => {
    return import(
      /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/Admin'
    );
  },
  props: true,
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    requiresPermission: ['ADMIN', 'DEV', 'SALES'],
    checkAdminPermissions: true,
    hidden: true,
    header: 'Admin',
  },
  children: [
    {
      path: '',
      name: 'admin',
      props: true,
      component: lazyLoadMetrics('AdminMetrics'),
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Admin',
      },
    },
    {
      path: 'metrics',
      name: 'AdminMetrics',
      component: lazyLoadMetrics('AdminMetrics'),
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Metrics',
      },
    },
    {
      path: 'metrics/courses',
      name: 'AdminCourseMetrics',
      component: lazyLoadMetrics('AdminCourseMetrics'),
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Course Metrics',
      },
    },
    {
      path: 'metrics/game-modes',
      name: 'AdminGameModeMetrics',
      component: lazyLoadMetrics('AdminGameModeMetrics'),
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Game Mode Metrics',
      },
    },
    {
      path: 'metrics/club-type',
      name: 'AdminClubMetrics',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/metrics/AdminClubMetrics.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Shots Per Club Metrics',
      },
    },
    {
      path: 'metrics/tracking-systems',
      name: 'AdminTrackingSystemMetrics',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/metrics/AdminTrackingSystemMetrics.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Shots Per Tracking System Metrics',
      },
    },
    {
      path: 'metrics/users',
      name: 'AdminUserMetrics',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/metrics/AdminUserMetrics.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'User Metrics',
      },
    },
    {
      path: 'metrics/shots',
      name: 'AdminShotsMetrics',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/metrics/AdminShotMetrics.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Shot Metrics',
      },
    },
    {
      path: 'metrics/practice-areas',
      name: 'AdminPracticeMetrics',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/metrics/AdminPracticeMetrics.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Practice Area Shot Metrics',
      },
    },
    {
      path: 'license-query',
      name: 'AdminLicenseQuery',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminLicenseQuery.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'ACCOUNTING', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'License Query',
      },
    },
    {
      path: 'license-management',
      name: 'AdminLicenseManagement',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminLicenseManagement.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'ACCOUNTING', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'User License Management',
      },
    },
    //* License Creation ======================================
    {
      path: 'license-create',
      name: 'AdminLicenseCreate',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminLicenseCreate.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Add User License',
      },
    },
    {
      path: 'sales-data',
      name: 'AdminSalesData',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminSalesData.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'ACCOUNTING'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Sales Data Export',
      },
    },
    {
      path: 'quarterly-report',
      name: 'AdminQuarterlyReport',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminQuarterReport.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'ACCOUNTING'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Quarterly Report Export',
      },
    },
    {
      path: 'transactions',
      name: 'AdminTransactions',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminTransactions.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'ACCOUNTING'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Transactions',
      },
    },
    {
      path: 'add-product',
      name: 'AdminAddProduct',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminAddProduct.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Add Product to License',
      },
    },
    {
      path: 'product-keys',
      name: 'AdminProductKeys',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProductKeys.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Product Keys',
      },
    },
    //* Products
    {
      path: 'products',
      name: 'AdminProducts',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProducts.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Products',
      },
    },
    {
      path: 'product/new',
      name: 'AdminProductNew',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProductNew.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Product',
      },
    },
    {
      path: 'product/:sku',
      name: 'AdminProduct',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProduct.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Product Details',
      },
    },
    {
      path: 'product/:sku/edit',
      name: 'AdminProductEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProductEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Product Details',
      },
    },
    {
      path: 'clubhouses',
      name: 'AdminClubhouses',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminClubhouses.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        clubhouseToolbar: false,
        hidden: true,
        header: 'Clubhouses',
      },
    },
    {
      path: 'clubhouse/new',
      name: 'AdminClubhouseCreate',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminClubhouseCreate.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Create Clubhouse',
      },
    },
    {
      path: 'clubhouse/:clubhouseID',
      name: 'AdminClubhouse',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminClubhouse.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        clubhouseToolbar: false,
        hidden: true,
        header: 'Clubhouse Details',
      },
    },
    {
      path: 'clubhouse/:clubhouseID/edit',
      name: 'AdminClubhouseEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminClubhouseEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        clubhouseToolbar: false,
        hidden: true,
        header: 'Edit Clubhouse',
      },
    },
    {
      path: 'clubhouse-licenses',
      name: 'AdminClubhouseLicenses',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminClubhouseLicenses.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Clubhouse Licenses',
      },
    },
    {
      path: 'clubhouse-license/new',
      name: 'AdminClubhouseLicenseCreate',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminClubhouseLicenseCreate.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Clubhouse License',
      },
    },
    {
      path: 'clubhouse-members',
      name: 'AdminClubmembers',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminClubmembers.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Clubhouse Member Management',
      },
    },
    {
      path: 'clubhouse-members/new',
      name: 'AdminClubmemberNew',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminClubmemberNew.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Clubhouse Member',
      },
    },
    {
      path: 'license-redemptions',
      name: 'AdminNewLicenseRedemptions',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminNewLicenseData.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'SALES', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New License Redemptions',
      },
    },
    {
      path: 'expiring-subscriptions',
      name: 'AdminExpiringSubscriptions',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminExpiringSubscriptions.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'SALES', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Expiring Subscriptions',
      },
    },
    //* Game Modes
    {
      path: 'game_modes',
      name: 'AdminGameModes',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminGameModes.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Game Modes',
      },
    },
    {
      path: 'game_mode/new',
      name: 'AdminGameModeNew',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminGameModeNew.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Game Mode',
      },
    },
    {
      path: 'game_mode/:key/edit',
      name: 'AdminGameModeEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminGameModeEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Game Mode',
      },
    },
    //* Simulator Permissions
    {
      path: 'simulator_permissions',
      name: 'AdminSimulatorPermissions',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminSimulatorPermissions.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Simulator Permissions',
      },
    },
    {
      path: 'simulator_permission/new',
      name: 'AdminSimulatorPermissionNew',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminSimulatorPermissionNew.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Simulator Permission',
      },
    },
    {
      path: 'simulator_permission/:key/edit',
      name: 'AdminSimulatorPermissionEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminSimulatorPermissionEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Simulator Permission',
      },
    },
    //* Tracking Systems
    {
      path: 'tracking_systems',
      name: 'AdminTrackingSystems',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminTrackingSystems.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Tracking Systems',
      },
    },
    {
      path: 'tracking_system/new',
      name: 'AdminTrackingSystemNew',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminTrackingSystemNew.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Tracking System',
      },
    },
    {
      path: 'tracking_system/:key/edit',
      name: 'AdminTrackingSystemEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminTrackingSystemEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Tracking System',
      },
    },
    //* Courses
    {
      path: 'courses',
      name: 'AdminCourses',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminCourses.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Courses',
      },
    },
    {
      path: 'course/upload',
      name: 'AdminCourseUpload',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminCourseUpload.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Course',
      },
    },
    {
      path: 'course/:id',
      name: 'AdminCourse',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminCourse.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Course Details',
      },
    },
    {
      path: 'course/:id/edit',
      name: 'AdminCourseEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminCourseEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Course',
      },
    },
    {
      path: 'course_version/:versionID',
      name: 'AdminCourseVersion',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminCourseVersion.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Course Version Details',
      },
    },
    {
      path: 'course_version/:versionID/edit',
      name: 'AdminCourseVersionEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminCourseVersionEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Course Version',
      },
    },

    // {
    //   path: 'course/:key/edit',
    //   name: 'AdminCourseEdit',
    //   component: () => {
    //     return import(
    //       /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminCourseEdit.vue'
    //     );
    //   },
    //   props: true,
    //   meta: {
    //     requiresAuth: true,
    //     requiresAdmin: true,
    //     requiresAccounting: true,
    //     requiresPermission: ['ADMIN'],
    //     checkAdminPermissions: true,
    //     hidden: true,
    //     header: 'Edit Course',
    //   },
    // },
    //* Bundles
    {
      path: 'bundles',
      name: 'AdminBundles',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminBundles.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Bundles',
      },
    },
    {
      path: 'bundle/new',
      name: 'AdminBundleNew',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminBundleNew.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Bundle',
      },
    },
    {
      path: 'bundle/:id',
      name: 'AdminBundle',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminBundle.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Bundle Details',
      },
    },
    {
      path: 'bundle/:id/edit',
      name: 'AdminBundleEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminBundleEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Bundle',
      },
    },
    //* Users ======================================
    {
      path: 'users',
      name: 'AdminUsers',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminUsers.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Users',
      },
    },
    {
      path: 'user/:id',
      name: 'AdminUser',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminUser.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'User Details',
      },
    },
    {
      path: 'user/:id/edit',
      name: 'AdminUserEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminUserEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit User',
      },
    },
    //* Partners ======================================
    {
      path: 'partners',
      name: 'AdminPartners',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminPartners.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Partners',
      },
    },
    {
      path: 'partners/new',
      name: 'AdminPartnerNew',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminPartnerNew.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Partner',
      },
    },
    {
      path: 'partners/:id/edit',
      name: 'AdminPartnerEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminPartnerEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Partner',
      },
    },
    {
      path: 'productkeys/report',
      name: 'AdminPartnerProductKeyReport',
      props: true,
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "partnerPages" */ '@/views/admin/AdminPartnerProductKeysReport'
        );
      },
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'ACCOUNTING'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Partner Product Key Report',
        title: 'Partner Product Key Report',
      },
    },
    //* Documentation ======================================
    {
      path: 'documentation',
      name: 'AdminDocumentationList',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminDocs.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Documentation',
      },
    },
    {
      path: 'documentation/new',
      name: 'AdminDocumentationCreate',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminDocCreate.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Create Document',
      },
    },
    {
      path: 'documentation/:id',
      name: 'AdminDocumentation',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminDoc.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Document Details',
      },
    },
    //* Game Versions ======================================
    {
      path: 'game_versions',
      name: 'AdminGameVersionList',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminGameVersions.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Game Versions',
      },
    },
    {
      path: 'game_version/new',
      name: 'AdminGameVersionCreate',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminGameVersionCreate.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Create Game Version',
      },
    },
    {
      path: 'game_version/:id/edit',
      name: 'AdminGameVersionEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminDoc.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Game Version Update',
      },
    },
    //* Game Client Downloads ======================================
    {
      path: 'game_downloads',
      name: 'AdminGameDownloadList',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminGameDownloads.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SALES', 'SUPPORT', 'ACTIVATIONS'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Game Downloads',
      },
    },
    {
      path: 'game_download/new',
      name: 'AdminGameDownloadCreate',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminGameDownloadCreate.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Create Game Download',
      },
    },
    {
      path: 'game_download/:id/edit',
      name: 'AdminGameDownloadEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminGameDownloadEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Game Download Update',
      },
    },
    //* Admin Request Log ======================================
    {
      path: 'logs',
      name: 'AdminRequestLog',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminLog.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Admin Request Logs',
      },
    },
    //* Events ======================================
    {
      path: 'events',
      name: 'AdminEvents',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminEvents.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SUPPORT'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Events',
      },
    },
    {
      path: 'event/:id',
      name: 'AdminEvent',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminEvent.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV', 'SUPPORT'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Event Details',
      },
    },
    {
      path: 'event/:id/edit',
      name: 'AdminEventEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminEventEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Event Details',
      },
    },
    //* Product Boards ======================================
    {
      path: 'boards',
      name: 'AdminProductBoards',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProductBoards.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Product Boards',
      },
    },
    {
      path: 'board/create',
      name: 'AdminProductBoardCreate',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProductBoardCreate.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Create Product Board',
      },
    },
    // {
    //   path: 'board/:id',
    //   name: 'AdminProductBoard',
    //   component: () => {
    //     return import(
    //       /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProductBoard.vue'
    //     );
    //   },
    //   props: true,
    //   meta: {
    //     requiresAuth: true,
    //     requiresAdmin: true,
    //     requiresPermission: ['ADMIN', 'DEV'],
    //     checkAdminPermissions: true,
    //     hidden: true,
    //     header: 'Product Boards',
    //   },
    // },
    {
      path: 'board/:id/edit',
      name: 'AdminProductBoardEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminProductBoardEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Product Boards',
      },
    },
    //* Challenges
    {
      path: 'challenges',
      name: 'AdminChallenges',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminChallenges.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Challenges',
      },
    },
    {
      path: 'challenges/new',
      name: 'AdminChallengeNew',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminChallengeNew.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'New Challenge',
      },
    },
    {
      path: 'challenges/:id/edit',
      name: 'AdminChallengeEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminChallengeEdit.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN', 'DEV'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit Challenge',
      },
    },
    //* TruSim API Partners
    {
      path: 'trusimapi_partners',
      name: 'AdminTruSimAPIPartners',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminTruSimPartners.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'TruSim API Partners',
      },
    },
    {
      path: 'trusimapi_partners/:id',
      name: 'AdminTruSimAPIPartner',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminTruSimPartner.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'API Partner',
      },
    },
    {
      path: 'trusimapi_partners/:id/edit',
      name: 'AdminTruSimAPIPartnerEdit',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "adminPages" */ '@/views/admin/AdminTruSimPartners.vue'
        );
      },
      props: true,
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        requiresAccounting: true,
        requiresPermission: ['ADMIN'],
        checkAdminPermissions: true,
        hidden: true,
        header: 'Edit API Partner',
      },
    },
  ],
};

export { adminRoutes };
